var exports = {
  "pI": "LeaderboardPodium.module__podium___UUt5bW",
  "ik": "LeaderboardPodium.module__place___UUt5bW",
  "OC": "LeaderboardPodium.module__player___UUt5bW",
  "my": "LeaderboardPodium.module__avatar___UUt5bW",
  "kp": "LeaderboardPodium.module__nameLine___UUt5bW",
  "UU": "LeaderboardPodium.module__name___UUt5bW",
  "PM": "LeaderboardPodium.module__step___UUt5bW",
};

module.exports = exports;
